export default function CTA() {
  return (
    <section id="cotizacion" className="py-24 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/414aee0da96785ef09e9e34f94832ea5.jpg"
          alt="Almacén industrial HIPERCLEAN"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-900/95 via-navy-800/90 to-royal-700/85"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Left: Text */}
          <div>
            <span className="inline-block text-xs font-semibold tracking-widest text-royal-300 uppercase mb-5">
              Clientes Empresariales
            </span>
            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6 leading-tight">
              Solicita una cotización<br />
              <span className="text-royal-300">para tu empresa</span>
            </h2>
            <p className="text-white/80 text-base leading-relaxed mb-8 max-w-lg">
              Trabajamos con empresas, industrias manufactureras, sector salud, hotelería y gobierno. Ofrecemos contratos de suministro continuo, precios por volumen y asesoría técnica especializada.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mb-10">
              {[
                { value: '+200', label: 'Empresas atendidas' },
                { value: '48h', label: 'Tiempo de entrega' },
                { value: '100%', label: 'Satisfacción garantizada' },
              ].map((stat, i) => (
                <div key={i} className="text-center border-r border-white/20 last:border-0">
                  <div className="text-3xl font-bold text-white mb-1">{stat.value}</div>
                  <div className="text-xs text-white/60 leading-tight">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="https://wa.me/524492037021?text=Hola%2C%20me%20interesa%20solicitar%20una%20cotizaci%C3%B3n%20empresarial%20para%20mi%20empresa."
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition-colors flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-lg"></i>
                </div>
                Cotizar por WhatsApp
              </a>
              <a
                href="tel:4499171543"
                className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-semibold rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-lg"></i>
                </div>
                449 917 1543
              </a>
            </div>
          </div>

          {/* Right: Form */}
          <div className="bg-white rounded-2xl p-8 shadow-2xl">
            <h3 className="text-xl font-bold text-gray-900 mb-2">Solicitud de Cotización</h3>
            <p className="text-gray-500 text-sm mb-6">Completa el formulario y te contactamos en menos de 24 horas.</p>

            <form
              id="cta-quote-form"
              data-readdy-form
              action="https://readdy.ai/api/form/d6fkn771jbcgr9kd717g"
              method="POST"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const params = new URLSearchParams();
                formData.forEach((value, key) => {
                  params.append(key, value.toString());
                });
                try {
                  const res = await fetch('https://readdy.ai/api/form/d6fkn771jbcgr9kd717g', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: params.toString(),
                  });
                  if (res.ok) {
                    const btn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
                    if (btn) {
                      btn.textContent = '✓ Solicitud enviada';
                      btn.disabled = true;
                      btn.classList.add('bg-green-600');
                      btn.classList.remove('bg-royal-600', 'hover:bg-royal-700');
                    }
                    form.reset();
                  }
                } catch (error) {
                  console.error('Error al enviar formulario:', error);
                }
              }}
              className="space-y-4"
            >
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1">Nombre *</label>
                  <input
                    type="text"
                    name="nombre"
                    required
                    placeholder="Tu nombre"
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-royal-600 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1">Empresa *</label>
                  <input
                    type="text"
                    name="empresa"
                    required
                    placeholder="Nombre de tu empresa"
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-royal-600 transition-colors"
                  />
                </div>
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">Correo electrónico *</label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="correo@empresa.com"
                  className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-royal-600 transition-colors"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1">Teléfono</label>
                  <input
                    type="tel"
                    name="telefono"
                    placeholder="449 000 0000"
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-royal-600 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1">Sector</label>
                  <select
                    name="sector"
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-royal-600 transition-colors cursor-pointer"
                  >
                    <option value="">Seleccionar...</option>
                    <option value="Manufactura">Manufactura</option>
                    <option value="Hotelería">Hotelería</option>
                    <option value="Salud">Salud</option>
                    <option value="Gobierno">Gobierno</option>
                    <option value="Alimenticio">Alimenticio</option>
                    <option value="Corporativo">Corporativo</option>
                    <option value="Otro">Otro</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">Productos o servicios de interés</label>
                <textarea
                  name="mensaje"
                  rows={3}
                  maxLength={500}
                  placeholder="Describe brevemente qué productos necesitas o el volumen estimado..."
                  className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-900 focus:outline-none focus:border-royal-600 transition-colors resize-none"
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full py-3.5 bg-royal-600 hover:bg-royal-700 text-white font-semibold rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer"
              >
                Enviar Solicitud de Cotización
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
